import { render } from "./BgBlur.vue?vue&type=template&id=71730510&scoped=true"
import script from "./BgBlur.vue?vue&type=script&lang=js"
export * from "./BgBlur.vue?vue&type=script&lang=js"

import "./BgBlur.vue?vue&type=style&index=0&id=71730510&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71730510"]])

export default __exports__